export default __webpack_public_path__ + "static/media/kiu.4af604d2.svg";